import React, { useState, useEffect, useMemo } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function FAQSection() {
  const [faqData, setFaqData] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Fetch FAQ data from WordPress ACF
  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const response = await fetch("https://easylearne.com/wp-json/acf/v3/pages/7");
        const data = await response.json();
        setFaqData(data?.acf || {});
      } catch (error) {
        console.error("Error loading FAQ:", error);
      }
    };

    fetchFAQ();
  }, []);

  // Convert flat ACF structure into FAQ entries
  const faqs = useMemo(() => {
    if (!faqData) return [];

    const formatted = [];

    Object.keys(faqData).forEach((key) => {
      if (key.startsWith("faq_question_")) {
        const index = key.split("_").pop();

        formatted.push({
          id: index,
          q: faqData[`faq_question_${index}`],
          a: faqData[`faq_answer_${index}`],
        });
      }
    });

    return formatted.sort((a, b) => Number(a.id) - Number(b.id));
  }, [faqData]);


  return (
    <section className="container bg-white py-14">
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 md:px-10 flex flex-col md:flex-row gap-10 items-start justify-center">

        {/* Left Content */}
        <div className="w-full md:w-[35%] text-center md:text-left">
          <h4 className="text-sm font-bold text-red-500 tracking-wide">FAQ</h4>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mt-2 leading-snug">
            Frequently Asked <br /> Questions.
          </h2>

          <p className="text-gray-600 mt-4 leading-relaxed max-w-[90%] md:max-w-full mx-auto md:mx-0">
            We provide expert counselling, admission assistance, and career guidance.
          </p>
        </div>

        {/* Right Accordion */}
        <div className="w-full md:w-[65%] space-y-4">
          {!faqData ? (
            <p className="text-gray-500 text-center">Loading...</p>
          ) : faqs.length === 0 ? (
            <p className="text-red-500 text-center">No FAQs added yet.</p>
          ) : (
            faqs.map((item, index) => (
              <div
                key={index}
                className="border rounded-lg bg-gray-50 shadow-sm overflow-hidden transition-all"
              >
                <button
                  className="w-full flex justify-between items-center p-4 text-left text-gray-800 font-medium hover:bg-gray-100 transition"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="pr-4">{item.q}</span>
                  {openIndex === index ? (
                    <ChevronUp className="text-green-500 w-5 h-5 shrink-0" />
                  ) : (
                    <ChevronDown className="text-green-500 w-5 h-5 shrink-0" />
                  )}
                </button>

                {/* Accordion Content */}
                <div
                  className={`transition-all duration-300 ease-in-out ${
                    openIndex === index ? "max-h-40 opacity-100 p-4 pt-0" : "max-h-0 opacity-0 p-0"
                  }`}
                >
                  <p className="text-gray-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
